import React from "react"
import Layout from "../components/Layout"
import Side from "../components/Intro"
import Contacts from '../components/contact'
import SEO from "../components/SEO"

export default function Contact() {
  return (
    <Layout>
      <SEO title="Contact" description="Form to contact me" />
      <Side isOpen={true}>
        <Contacts />
      </Side>
    </Layout>
  )

}
